/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Result component
 *
 * @author Thais Watanabe
 */
const Result = ({ result, unit, isInputCorrect }) => {
  var badgeStyle = "";

  if (isInputCorrect) {
    badgeStyle = "bg-blue-100 text-blue-800";
  } else {
    badgeStyle = "bg-red-100 text-red-800";
  }

  if (result === "-" || result === "" || result === "補充不要" || result === "点検不要") {
    badgeStyle = "bg-gray-100 text-gray-800";
  } else if (result === "あり" || result === "失敗" || result === "不適合") {
    badgeStyle = "bg-red-100 text-red-800";
  } else if (result === "適合" || result === "なし" || result === "済" || result === "成功") {
    badgeStyle = "bg-blue-100 text-blue-800";
  } else if (result === "整備後適合" || result === "補充実施") {
    badgeStyle = "bg-green-100 text-green-800";
  } else if (result === "未済" || result === "未実施") {
    badgeStyle = "bg-yellow-100 text-yellow-800";
  } else if (result === "経過観察") {
    badgeStyle = "bg-orange-100 text-orange-800";
  }

  return (
    <span
      className={`${badgeStyle} inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium print:text-xxs print:px-1 print:py-0`}
    >
      {!result || result === "" ? "-" : result} {!result || result === "-"  ? "" : unit}
    </span>
  );
};

export default Result;
